function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var typographyStyles = theme => {
  var applyTypography = typographyKey => {
    return {
      WebkitFontSmoothing: 'auto',
      fontFamily: theme.typography.small[typographyKey].fontFamily,
      fontSize: theme.typography.small[typographyKey].fontSize,
      fontWeight: theme.typography.small[typographyKey].fontWeight,
      lineHeight: theme.typography.small[typographyKey].lineHeight,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontFamily: theme.typography.medium[typographyKey].fontFamily,
        fontSize: theme.typography.medium[typographyKey].fontSize,
        fontWeight: theme.typography.medium[typographyKey].fontWeight,
        lineHeight: theme.typography.medium[typographyKey].lineHeight
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontFamily: theme.typography.large[typographyKey].fontFamily,
        fontSize: theme.typography.large[typographyKey].fontSize,
        fontWeight: theme.typography.large[typographyKey].fontWeight,
        lineHeight: theme.typography.large[typographyKey].lineHeight
      }
    };
  };
  return {
    'h1, .title-large, .title-large--light': applyTypography('titleLarge'),
    'h2, .title-medium, .title-medium--light': applyTypography('titleMedium'),
    'h3, .title-regular, .title-regular--light': applyTypography('titleRegular'),
    'h4, .title-small, .title-small--light': applyTypography('titleSmall'),
    'h5, .subtitle-large, .subtitle-large--light': applyTypography('subtitleLarge'),
    'h6, .subtitle-regular, .subtitle-regular--light': applyTypography('subtitleRegular'),
    'body, .body, .body-regular': applyTypography('bodyRegular'),
    '.body-large': applyTypography('bodyLarge'),
    '.caption, .caption-regular': applyTypography('captionRegular'),
    '.caption-small': applyTypography('captionSmall'),
    '.label, .label-regular': applyTypography('labelRegular'),
    '.label-small': applyTypography('labelSmall'),
    '.overline, .overline-regular': _objectSpread({
      textTransform: 'uppercase'
    }, applyTypography('overlineRegular')),
    '.overline-large': _objectSpread({
      textTransform: 'uppercase'
    }, applyTypography('overlineLarge')),
    '.font-medium': {
      fontFamily: theme.typography.family0,
      fontWeight: theme.typography.weight4
    }
  };
};
export default typographyStyles;